import { Reveal } from "@components/ui";
import techImage from "@assets/images/Frame-2147224420@2x.png";

const bulletItems = [
  "Smart meters",
  "Digital inspection reports",
  "GIS mapping of gas networks",
  "Automated billing & AI-supported meter checking",
  "Customer portal & mobile-first UX",
];

export function TechInnovationSection() {
  return (
    <section className="w-full bg-[#f1f1f1] py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20 items-center">
          {/* Left side */}
          <Reveal direction="up">
            <div className="flex flex-col gap-6 md:gap-8">
              <h2 className="text-[28px] md:text-[40px] lg:text-[48px] xl:text-[54px] 2xl:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63] font-albert-sans leading-[1.1] lg:leading-[74px]">
                Our Technology & Innovation
              </h2>

              <ul className="flex flex-col gap-3">
                {bulletItems.map((item) => (
                  <li key={item} className="flex items-center gap-3">
                    <div className="w-3 h-3 rounded-full bg-[#62636c] shrink-0" />
                    <span className="text-[20px] md:text-[24px] text-[#62636c] tracking-[-0.04em] leading-[32px] font-albert-sans">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>

              <p className="text-[20px] md:text-[24px] text-[#62636c] tracking-[-0.04em] leading-[32px] font-albert-sans">
                This positions GASIS as a technology-driven utility provider.
              </p>
            </div>
          </Reveal>

          {/* Right side */}
          <Reveal direction="up" delay={100}>
            <img
              src={techImage}
              alt="GASIS Technology & Innovation"
              className="w-full rounded-[24px] object-cover"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
